import React, { Component } from 'react';
import Navbar from '../navbar';
import BookingDetails from '../booking-details';
import RegistrationDetails from '../registration-details/registration-details';
import RegistrationConfirmation from '../registration-confirmation'

class TrackdayRegistration extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            step: 0,
            details: null
        };


        this.handleDetailsValidated = this.handleDetailsValidated.bind(this);
        this.handleRegistration = this.handleRegistration.bind(this);
    }

    handleDetailsValidated(details) {
        this.setState({step: 1, details: details});
    }

    handleRegistration(details) {
        this.setState({step: 2, details: details});
    }


    render() {

        var mainContent;
        switch (this.state.step) {
            case 0:
                mainContent = <BookingDetails onDetailsValidated={this.handleDetailsValidated} eventDetails={this.props.eventDetails}/>
                break;
            case 1:
                mainContent = <RegistrationDetails details={this.state.details} onRegister={this.handleRegistration}/>
                break;
            case 2:
                mainContent = <RegistrationConfirmation details={this.state.details} />
                break;
            default:
                mainContent = "Please reload the page";
                break;
        }

        return <div>
                <Navbar step={this.state.step} />
                {mainContent}
            </div>
    }
}

export default TrackdayRegistration;